import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Toggle, ValueRow } from '../common';
import { useTheme } from './providers/DialectThemeProvider';
export default function ToggleSection({ title, checked, noBorder, children, onChange, disabled, hideToggle, }) {
    const { section } = useTheme();
    const inner = (_jsxs(_Fragment, { children: [_jsx(ValueRow, { className: clsx(checked && children && 'dt-mb-2'), label: title, children: !hideToggle && (_jsx(Toggle, { type: "checkbox", checked: checked, disabled: disabled, onChange: onChange })) }), checked && children] }));
    if (noBorder) {
        return inner;
    }
    return _jsx("div", { className: clsx(section), children: inner });
}
//# sourceMappingURL=ToggleSection.js.map